// extracted by mini-css-extract-plugin
var _1 = "PostSeriesInTopicList-module__seriesIcon--dCUMO";
export { _1 as "seriesIcon" }
